export class SubscriptionsMockup {
    static subscriptionEmail = {
        'id': 1,
        'name': 'Email Notification',
        'subscribed': false
    };

    static newsletters = {
        'id': 2,
        'name': 'Newsletters',
        'subscribed': true
    };

    static deals = {
        'id': 3,
        'name': 'Special Deals',
        'subscribed': false
    };

    static subsArray = [
        SubscriptionsMockup.subscriptionEmail,
        SubscriptionsMockup.newsletters,
        SubscriptionsMockup.deals
    ];
}
